import React, {useState, Fragment, useEffect} from 'react'
//import { LazyLoadImage } from 'react-lazy-load-image-component';
import {isNil} from 'lodash';

const Image = ({src, responsive, className}) => {
    const [responsiveImage, setResponsiveImage] = useState(null);
    //const [img, setImg] = useState(null);
    

    useEffect(() => {
        
        if(!responsive){
            setResponsiveImage(src);
        }else{
            setResponsiveImage(responsive);
        }
    }, [responsiveImage, src])

    return (
        <Fragment>
            {window.innerWidth <= 768 && responsiveImage && 
                <img src={responsiveImage} className={(!isNil(className)? className : "")} alt="" />
            }
            {window.innerWidth > 768 && 
                <img src={src} className={(!isNil(className)? className : "")} alt="" />
            }

        </Fragment>
    )
}

export default Image
